module.exports = __webpack_public_path__ + "static/media/ic-manager@2x.4f9db4b8.png";